import { useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import Container from "../../utils/Container";
import currentAdminContext from "../../../dataManager/context/currentAdminContext";
import Paragraph from "../../elements/p/Paragraph";
import LazyLoadImg from "../../elements/images/LazyLoadImg";

const Banner = () => {
  const { currentAdmin } = useContext(currentAdminContext);

  const pathToNavigate =
    currentAdmin?.getRole === 0 ? `/user/${currentAdmin?.getId}` : `/admin`;

  const loginOrUser = currentAdmin ? (
    <Link
      to={pathToNavigate}
      className="group my-1 flex cursor-pointer items-center space-x-2"
    >
      <Paragraph size="small" color="light">
        {currentAdmin.getName.slice(0, 20)}
      </Paragraph>
      <LazyLoadImg
        img={currentAdmin.getImage}
        alt={currentAdmin.getName}
        classe="w-8 h-8 w-full h-full  object-cover rounded-full border-2 border-smoot group-hover:border-primary animate"
      />
    </Link>
  ) : (
    <NavLink
      to="/connexion/user"
      className="animate block cursor-pointer bg-primary/10 py-2 px-3 text-smoot hover:bg-primary-dark"
    >
      Inscription | Connexion
    </NavLink>
  );

  return (
    <div className="hidden  bg-tersio md:block">
      <Container>
        <nav>
          <ul className="flex items-center justify-between font-nunito text-xs font-light md:text-sm">
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive
                  ? "text-primary"
                  : "animate text-smoot hover:text-primary-dark"
              }
            >
              Page d'accueil
            </NavLink>
            <NavLink
              to="/produits"
              className={({ isActive }) =>
                isActive
                  ? "text-primary"
                  : "animate text-smoot hover:text-primary-dark"
              }
            >
              Tous nos articles
            </NavLink>
            <NavLink
              to="/localisation"
              className={({ isActive }) =>
                isActive
                  ? "text-primary"
                  : "animate text-smoot hover:text-primary-dark"
              }
            >
              Nous localiser
            </NavLink>
            <a
              target="_blank"
              href="https://wa.me/237674651112"
              rel="noreferrer"
              className="animate cursor-pointer text-smoot hover:text-primary-dark" //wa.me/237674651112""
            >
              Nous contacter
            </a>

            {/* <NavLink
              to="/admin"
              className={({ isActive }) =>
                isActive
                  ? "text-primary"
                  : "animate text-smoot hover:text-primary-dark"
              }
            >
              admin
            </NavLink>

            <NavLink
              to="/connexion/admin"
              className={({ isActive }) =>
                isActive
                  ? "text-primary"
                  : "animate text-smoot hover:text-primary-dark"
              }
            >
              connexion admin
            </NavLink> */}
            {loginOrUser}
          </ul>
        </nav>
      </Container>
    </div>
  );
};

export default Banner;
